import React, { ReactNode } from "react";
import cx from "classnames";
import { useTranslation } from "i18n";
import "./InputLabel.scss";

export enum InputLabelStyleTypes {
  Primary = "primary",
  Secondary = "secondary",
}

export interface IInputLabelProps {
  label?: string | ReactNode;
  /** Optionally specify which element the label is for */
  htmlFor?: string;
  /** Optional component to display on the top-right */
  annex?: ReactNode;
  /** Place annex next to label */
  inlineAnnexPosition?: boolean;
  /** Remove margins */
  noMargin?: boolean;
  /** Make the text bold */
  bold?: boolean;
  /** Style type. Check out example for available options */
  styleType?: InputLabelStyleTypes;
  /** Optional text to display next to the label */
  optional?: boolean;
}

export const InputLabel = ({
  label,
  htmlFor,
  annex,
  inlineAnnexPosition,
  styleType,
  bold,
  noMargin,
  optional,
}: IInputLabelProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(`c-input-label`, {
        "c-input-label--with-annex": Boolean(annex),
        "c-input-label--inline-annex": inlineAnnexPosition,
        "c-input-label--no-margin": noMargin,
        "c-input-label--bold": bold,
        [`c-input-label--${styleType}`]: Boolean(styleType),
        "mb-0": !label && !annex,
      })}
    >
      {label ? (
        <label className="c-input-label__label" htmlFor={htmlFor}>
          {label}
        </label>
      ) : null}
      {annex ? <div className="c-input-label__annex">{annex}</div> : null}
      {optional && (
        <span className="text-s text-grey-stone-4 ml-auto">
          ({t("common:label.optional")})
        </span>
      )}
    </div>
  );
};
